import KeenAnalysis from 'keen-analysis';

const KeenClient = new KeenAnalysis({
  projectId: process.env.REACT_APP_KEEN_PROJECT_ID,
  readKey: process.env.REACT_APP_KEEN_READ_KEY,
});

export default KeenClient;
